import React from 'react';
import { IResourceComponentsProps } from '@refinedev/core';
import { Edit, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';

export const TypeEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps } = useForm();

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item
          label="Name"
          name={['name']}
          rules={[
            {
              required: true,
              message: 'Please enter a valid product type name.',
            },

            {
              min: 3,
              message: 'The type name must be at least [3 characters] long.',
            },
            {
              max: 30,
              message: 'The type name cannot be longer than [30 characters].',
            },
            {
              type: 'string',
              whitespace: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Edit>
  );
};
